import React from "react";
import { Link } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import Icon from "@/components/Icon";

const GUIDES = [
  { icon: "Contact", title: "Employee contact QRs", body: "Use the vCard destination. Pick 'Updateable' so editing an employee updates every printed code, or 'Direct' to embed the vCard in the image." },
  { icon: "RefreshCw", title: "Static vs dynamic", body: "Static encodes data in the image (no edits, no analytics). Dynamic uses a permanent QR Code Creator Studio link you can re-point anytime with full analytics." },
  { icon: "Palette", title: "Design studio", body: "Tune dots, corners, colors, gradients and logo. Watch the scanability score and use 'Improve scanability' if it dips." },
  { icon: "Layers", title: "Bulk creation", body: "Import a CSV of employees, apply one company design, publish, and download a ZIP of individual QR + vCard files." },
  { icon: "BarChart3", title: "Analytics", body: "Dynamic codes show scans, unique estimates, devices, OS, and geography. Static codes clearly show analytics are unavailable." },
];

export default function HelpApp() {
  return (
    <AppLayout>
      <h1 className="text-2xl font-display font-extrabold mb-1">Help & guides</h1>
      <p className="text-sm text-muted-foreground mb-6">Everything you need to build great QR codes.</p>
      <div className="grid md:grid-cols-2 gap-4 max-w-4xl">
        {GUIDES.map((g) => (
          <div key={g.title} className="rounded-2xl border border-border bg-card p-5">
            <div className="h-10 w-10 rounded-xl bg-primary/10 grid place-items-center mb-3"><Icon name={g.icon} className="h-5 w-5 text-primary" /></div>
            <h3 className="font-display font-bold">{g.title}</h3>
            <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{g.body}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 rounded-2xl border border-border bg-card p-5 max-w-4xl text-sm text-muted-foreground">
        Read our public <Link to="/help" className="text-primary font-semibold">FAQ & privacy policy</Link> for details on cancellation, grace periods and data handling.
      </div>
    </AppLayout>
  );
}
